import { OutputValues } from "./types";

export function statutoryPension({
  statutory_pension: D4,
  statutory_pension_increase,
  age_entry: E10,
  age_till: E12,
  inflation: E18,
}: Pick<
  OutputValues,
  | "statutory_pension_increase"
  | "statutory_pension"
  | "age_till"
  | "age_entry"
  | "inflation"
>) {
  /*
  =PV((1+(D6))^(1/12)-1;
  (Ergebnis_Eingaben!E12-Ergebnis_Eingaben!E10)*12;
  -((FV((Ergebnis_Eingaben!E18)/12;
      (Ergebnis_Eingaben!E12-Ergebnis_Eingaben!E10)*12;
      -1*(D4/((Ergebnis_Eingaben!E12-Ergebnis_Eingaben!E10)*12))))))
   */

  if (!D4 || D4 <= 0) return 0;
  const D6 = statutory_pension_increase ?? 0;

  const a = (1 + D6) ** (1 / 12) - 1;
  const b = (E12 - E10) * 12;
  const _c = E18 / 12;
  const _d = (E12 - E10) * 12;
  const _e = -1 * (D4 / ((E12 - E10) * 12));
  return PV(a, b, -FV(_c, _d, _e));
}

export function privatePension1({
  ruerup_pension: D4,
  ruerup_pension_monthly: E4,
  age: _E6,
  age_entry: _E10,
  performance_savings: _E20,
}: Pick<
  OutputValues,
  | "ruerup_pension"
  | "ruerup_pension_monthly"
  | "performance_savings"
  | "age_entry"
  | "age"
>): number {
  /*
  =(D4*(1+(Ergebnis_Eingaben!E20))^(Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)
  +(FV((Ergebnis_Eingaben!E20/12);
      (Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)*12;
      (-1*E4))))
   */

  if (!D4 || D4 <= 0) return 0;

  const a = D4 * (1 + _E20) ** (_E10 - _E6);
  const _b = _E20 / 12;
  const _c = (_E10 - _E6) * 12;
  const _d = -E4;
  return a + FV(_b, _c, _d);
}

export function privatePension2({
  riester_pension: D6,
  riester_pension_monthly: E6,
  age: _E6,
  age_entry: _E10,
  performance_savings: _E20,
}: Pick<
  OutputValues,
  | "riester_pension"
  | "riester_pension_monthly"
  | "performance_savings"
  | "age_entry"
  | "age"
>): number {
  /*
  =(D6*(1+(Ergebnis_Eingaben!E20))^(Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)
  +(FV((Ergebnis_Eingaben!E20/12);
      (Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)*12;
      (-1*E6))))
   */
  if (!D6 || D6 <= 0) return 0;

  const a = D6 * (1 + _E20) ** (_E10 - _E6);
  const _b = _E20 / 12;
  const _c = (_E10 - _E6) * 12;
  const _d = -E6;
  return a + FV(_b, _c, _d);
}

export function privatePension3({
  private_pension: D8,
  private_pension_monthly: E8,
  age: _E6,
  age_entry: _E10,
  performance_savings: _E20,
}: Pick<
  OutputValues,
  | "private_pension"
  | "private_pension_monthly"
  | "performance_savings"
  | "age_entry"
  | "age"
>): number {
  /*
  =(D8*(1+(Ergebnis_Eingaben!E20))^(Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)
  +(FV((Ergebnis_Eingaben!E20/12);
      (Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)*12;
      (-1*E8))))
   */

  if (!D8 || D8 <= 0) return 0;

  const a = D8 * (1 + _E20) ** (_E10 - _E6);
  const _b = _E20 / 12;
  const _c = (_E10 - _E6) * 12;
  const _d = -E8;
  return a + FV(_b, _c, _d);
}

export function rentIncome({
  rent: C4,
  rent_increase: D4,
  age_till: _E12,
  age_entry: _E10,
  inflation: _E18,
}: Pick<
  OutputValues,
  "rent" | "rent_increase" | "age_till" | "age_entry" | "inflation"
>): number {
  /*
  =PV((1+(D4))^(1/12)-1;
    (Ergebnis_Eingaben!E12-Ergebnis_Eingaben!E10)*12;
      -((FV((Ergebnis_Eingaben!E18)/12;
          (Ergebnis_Eingaben!E12-Ergebnis_Eingaben!E10)*12;
          -1*(C4/((Ergebnis_Eingaben!E12-Ergebnis_Eingaben!E10)*12))))))
   */

  if (!C4 || C4 <= 0) return 0;

  const a = (1 + D4) ** (1 / 12) - 1;
  const b = (_E12 - _E10) * 12;
  const _d = _E18 / 12;
  const _e = (_E12 - _E10) * 12;
  const _f = -1 * (C4 / ((_E12 - _E10) * 12));
  return PV(a, b, -FV(_d, _e, _f));
}

export function capital({
  depot: E4,
  depot_monthly: E6,
  performance_savings: _E20,
  age: _E6,
  age_entry: _E10,
}: Pick<
  OutputValues,
  "depot" | "depot_monthly" | "performance_savings" | "age_entry" | "age"
>): number {
  /*
  =(E4*(1+(Ergebnis_Eingaben!E20))^(Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)
  +(FV((Ergebnis_Eingaben!E20/12);
      (Ergebnis_Eingaben!E10-Ergebnis_Eingaben!E6)*12;
      (-1*E6))))
   */

  if (!E4 || E4 <= 0) return 0;

  const a = E4 * (1 + _E20) ** (_E10 - _E6);
  const _b = _E20 / 12;
  const _c = (_E10 - _E6) * 12;
  const _d = -E6;
  const _fv = FV(_b, _c, _d);

  return a + _fv;
}

export type WishPensionWithAgeArgs = {
  currentWishPension: number;
  age: number;
  age_entry: number;
  inflation: number;
};

export function wishPensionWithAge({
  age,
  age_entry,
  currentWishPension,
  inflation,
}: WishPensionWithAgeArgs): number {
  return currentWishPension * (1 + inflation) ** (age_entry - age);
}

export function PV(
  rate: number,
  periods: number,
  payment: number,
  future?: number,
  type?: number
) {
  future = future || 0;
  type = type || 0;

  // Return present value
  if (rate === 0) {
    return -payment * periods - future;
  } else {
    return (
      (((1 - Math.pow(1 + rate, periods)) / rate) *
        payment *
        (1 + rate * type) -
        future) /
      Math.pow(1 + rate, periods)
    );
  }
}

function FV(
  rate: number,
  periods: number,
  payment: number,
  value$1?: number,
  type?: number
) {
  // Credits: algorithm inspired by Apache OpenOffice
  value$1 = value$1 || 0;
  type = type || 0;

  // Return future value
  let result;

  if (rate === 0) {
    result = value$1 + payment * periods;
  } else {
    const term = Math.pow(1 + rate, periods);

    if (type === 1) {
      result = value$1 * term + (payment * (1 + rate) * (term - 1)) / rate;
    } else {
      result = value$1 * term + (payment * (term - 1)) / rate;
    }
  }

  return -result;
}

export function neededCapital({
  performance_withdrawal: E21,
  age_entry: E10,
  age_till: E12,
  inflation: E18,
  pension_inflation: G8,
}: Pick<
  OutputValues,
  "performance_withdrawal" | "age_entry" | "age_till" | "inflation"
> & {
  pension_inflation: number;
}): number {
  /*
  =PV((1+(E21))^(1/12)-1;
      (E12-E10)*12;
      -((FV((E18)/12;
          (E12-E10)*12;
          -1*(G8/((E12-E10)*12))))))
   */

  const _a = (1 + E21) ** (1 / 12) - 1;
  const _b = (E12 - E10) * 12;
  const _d = E18 / 12;
  const _e = (E12 - E10) * 12;
  const _f = -(G8 / ((E12 - E10) * 12));

  return PV(_a, _b, -FV(_d, _e, _f));
}

export type AdditionalSavingsRate = Pick<
  OutputValues,
  "performance_savings" | "age" | "age_entry"
> & {
  missingCapital: number;
};

export function additionalSavingsRate({
  performance_savings: E14,
  age: D5,
  age_entry: D6,
  missingCapital: D22,
}: AdditionalSavingsRate) {
  return (D22 * -(E14 / 12)) / (1 - (1 + -(E14 / 12)) ** -((D6 - D5) * 12));
}

export function overViewData({
  age,
  age_entry,
  age_till,
  depot,
  depot_monthly,
  inflation,
  performance_savings,
  private_pension,
  private_pension_monthly,
  rent,
  rent_increase,
  riester_pension,
  riester_pension_monthly,
  ruerup_pension,
  ruerup_pension_monthly,
  statutory_pension,
  statutory_pension_increase,
}: OutputValues): {
  statutoryPension: number;
  rent: number;
  capital: number;
  private1: number;
  private2: number;
  private3: number;
  preparedCapital: number;
} {
  const _statutoryPension = statutoryPension({
    statutory_pension,
    age_entry,
    age_till,
    inflation,
    statutory_pension_increase,
  });

  const _p1 = privatePension1({
    age,
    age_entry,
    performance_savings,
    ruerup_pension_monthly,
    ruerup_pension,
  });
  const _p2 = privatePension2({
    age,
    age_entry,
    performance_savings,
    riester_pension_monthly,
    riester_pension,
  });
  const _p3 = privatePension3({
    age,
    age_entry,
    performance_savings,
    private_pension_monthly,
    private_pension,
  });

  const _rent = rentIncome({
    rent,
    inflation,
    rent_increase,
    age_entry,
    age_till,
  });

  const _capital = capital({
    age,
    age_entry,
    performance_savings,
    depot,
    depot_monthly,
  });

  const _preparedCapital =
    _statutoryPension + _p1 + _p2 + _p3 + _rent + _capital;

  return {
    statutoryPension: _statutoryPension,
    rent: _rent,
    capital: _capital,
    private1: _p1,
    private2: _p2,
    private3: _p3,
    preparedCapital: _preparedCapital,
  };
}
